export default class SimpleStorage<T> {
  key: string;

  constructor(key: string) {
    this.key = key;
  }

  static getOrCreate<T>(key: string, initialValue: T) {
    const simpleStorage = new SimpleStorage<T>(key);
    simpleStorage.setOnce(initialValue);
    return simpleStorage;
  }

  set(value: T) {
    localStorage.setItem(this.key, this.toJson(value));
  }

  get(): T {
    const item = localStorage.getItem(this.key);
    return this.toObject(item);
  }

  remove() {
    localStorage.removeItem(this.key);
  }

  private setOnce(value: T) {
    const hasValue = localStorage.getItem(this.key);
    if (hasValue) return;

    this.set(value);
  }
  private toJson(value: T) {
    return JSON.stringify(value);
  }

  private toObject(json: string): T {
    return JSON.parse(json);
  }
}
